import { styled } from 'parkdepot-shared/theme'

const AddVehicleWrapper = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    lineHeight: '2.4rem',
    fontWeight: 500,
    color: $theme.colors.primary,
    display: 'flex',
    gap: '0.8rem',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    marginTop: '1.6rem'
}))

export default AddVehicleWrapper
